<template>
  <div class="woo-404">
    <div class="woo-404-wrapper">
      <v-img
        :src="require(`@/assets/404.jpeg`)"
        :lazy-src="require(`@/assets/404.jpeg`)"
        class="woo-404-hero"
      ></v-img>
      <h1>It's a yarn-mergency!</h1>
      <div>The page you're looking for doesn't exist, but fret not. Just keep calm and wooble on.</div>
      <div v-if="errorMessage" class="error-details">
        <strong>Error:</strong> {{ errorMessage }}
      </div>
      <v-btn :to="`/`" class="woo-button" elevation="2" rounded>
        back to all guides
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    errorMessage() {
      return this.$route.query.error || '';
    }
  }
}
</script>

<style lang="scss" scoped>
.woo {
  &-404 {
    line-height: 1.5 !important;
    color: rgba(113, 34, 0, 1);
    width: 100%;
    height: 100%;
    background-color: rgba(255, 192, 92, 1);
    
    &-wrapper {
      top: 40%;
      position: relative;
      padding: 20px;
      transform: translateY(-50%);
      max-width: 450px;
      margin: auto;
    }
  }
  &-button {
    background-color: rgba(113, 34, 0, 1) !important;
    color: #fff;
    height: 3rem !important;
    width: 14.875rem;
    margin-top: 1.5rem;
    font-size: 1.125rem;
    font-weight: 800;
    line-height: 1.3125rem;
    letter-spacing: 0em;
    text-align: center;
  }
}
.error-details {
  color: 'red';
  margin-top: 1rem;
  font-weight: bold;
}
</style>
